import lang from '@/lang'

export const ECONOMIC_ASSET_STATUS = {
  OPEN: 'open',
  FULLY_DEPRECIATED: 'fullyDepreciated',
  COMPLETED: 'completed',
}

const ECONOMIC_ASSET_STATUS_MAP = {
  open: ECONOMIC_ASSET_STATUS.OPEN,
  fullyDepreciated: ECONOMIC_ASSET_STATUS.FULLY_DEPRECIATED,
  completed: ECONOMIC_ASSET_STATUS.COMPLETED,
}

export const ECONOMIC_ASSET_TYP = {
  LINEAR: 'linear',
  DEGRESSIVE: 'decliningBalance',
  LOWVALUEASSET: 'lowValueAsset',
  ELECTRIC_VEHICLE_SPECIAL: 'electricVehicleSpecial',
}

const ECONOMIC_ASSET_TYP_MAP = {
  linear: ECONOMIC_ASSET_TYP.LINEAR,
  decliningBalance: ECONOMIC_ASSET_TYP.DEGRESSIVE,
  lowValueAsset: ECONOMIC_ASSET_TYP.LOWVALUEASSET,
  electricVehicleSpecial: ECONOMIC_ASSET_TYP.ELECTRIC_VEHICLE_SPECIAL,
}

export const ECONOMIC_ASSET_SPECIAL_DEPRECIATION_TYP = {
  LOSS_OR_DESTRUCTION: 'lossOrDestruction',
  SALE: 'sale',
  TRANSFER_TO_PRIVATE_OWNERSHIP: 'transferToPrivateOwnership',
}

const ECONOMIC_ASSET_SPECIAL_DEPRECIATION_TYP_MAP = {
  lossOrDestruction: ECONOMIC_ASSET_SPECIAL_DEPRECIATION_TYP.LOSS_OR_DESTRUCTION,
  sale: ECONOMIC_ASSET_SPECIAL_DEPRECIATION_TYP.SALE,
  transferToPrivateOwnership: ECONOMIC_ASSET_SPECIAL_DEPRECIATION_TYP.TRANSFER_TO_PRIVATE_OWNERSHIP,
}

const ECONOMIC_ASSET_SPECIAL_DEPRECIATION_LABEL = {
  [ECONOMIC_ASSET_SPECIAL_DEPRECIATION_TYP.LOSS_OR_DESTRUCTION]: lang.economicAsset.specialDepreciation.lossOrDestruction,
  [ECONOMIC_ASSET_SPECIAL_DEPRECIATION_TYP.SALE]: lang.economicAsset.specialDepreciation.sale,
  [ECONOMIC_ASSET_SPECIAL_DEPRECIATION_TYP.TRANSFER_TO_PRIVATE_OWNERSHIP]: lang.economicAsset.specialDepreciation.transferToPrivateOwnership,
}

const ECONOMIC_ASSET_STATUS_LABEL = {
  [ECONOMIC_ASSET_STATUS.OPEN]: lang.economicAsset.status.open,
  [ECONOMIC_ASSET_STATUS.FULLY_DEPRECIATED]: lang.economicAsset.status.fullyDepreciated,
  [ECONOMIC_ASSET_STATUS.COMPLETED]: lang.economicAsset.status.completed,
}

const ECONOMIC_ASSET_TYP_LABEL = {
  [ECONOMIC_ASSET_TYP.LINEAR]: lang.economicAsset.type.linear,
  [ECONOMIC_ASSET_TYP.DEGRESSIVE]: lang.economicAsset.type.degressive,
  [ECONOMIC_ASSET_TYP.LOWVALUEASSET]: lang.economicAsset.type.lowValueAsset,
  [ECONOMIC_ASSET_TYP.ELECTRIC_VEHICLE_SPECIAL]: lang.economicAsset.type.electricVehicleSpecial,
}

export const getEconomicAssetStatusLabel = (status) => {
  const economicAssetStatus = ECONOMIC_ASSET_STATUS_MAP[status]
  const economicAssetStatusLabel = ECONOMIC_ASSET_STATUS_LABEL[economicAssetStatus]

  return economicAssetStatusLabel
}

export const getEconomicAssetTypLabel = (typ) => {
  const economicAssetTyp = ECONOMIC_ASSET_TYP_MAP[typ]
  const economicAssetTypeLabel = ECONOMIC_ASSET_TYP_LABEL[economicAssetTyp]

  return economicAssetTypeLabel
}

export const getSpecialDepreciationTypeLabel = (typ) => {
  const specialDepreciationTyp = ECONOMIC_ASSET_SPECIAL_DEPRECIATION_TYP_MAP[typ]
  const specialDepreciationTypeLabel = ECONOMIC_ASSET_SPECIAL_DEPRECIATION_LABEL[specialDepreciationTyp]

  return specialDepreciationTypeLabel
}

export const getYearForMonths = (month) => {
  const years = Math.floor(month / 12)
  const label = `${month} Mt. (${years}J)`
  return label
}

export const ECONOMIC_ASSET_QUICK_FILTER = {
  ALL: 'all',
  LT_TWO_YEARS: 'ltTwoYears',
  GT_TWO_YEARS: 'gtTwoYears',
  FULLY_DEPRECIATED: 'fullyDepreciated',
  COMPLETED: 'completed',
}

export const DEPRECATION_METHODS = {
  linear: 'linear',
  decliningBalance: 'decliningBalance',
  lowValueAsset: 'lowValueAsset',
  electricVehicleSpecial: 'electricVehicleSpecial',
}

export const ACCOUNT_CATEGORY = {
  investmentAccounts: 'Anlagekonten',
}

export const SPECIAL_DEPRECATION_PROPERTIES = {
  COMMENTS: 'comments',
  TYPE: 'type',
  DATE: 'date',
  VAT: 'vat',
  PRICEGROSS: 'priceGross',
}
